import { Box } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import * as React from "react";
import { FormattedMessage } from "react-intl";

import { useTableStyles } from "../../styles/tableStyles";

const RemittanceRunnerNoRecordsFound: React.FC = () => {
  const tblClasses = useTableStyles({});
  const numberOfColumns = 8;

  return (
    <div className={tblClasses.responsiveTable}>
      <Table>
        <TableBody className={tblClasses.tblBody}>
          <TableRow>
            <TableCell colSpan={numberOfColumns}>
              <Box className={tblClasses.boxStyles}>
                <FormattedMessage defaultMessage="No records found" />
              </Box>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default RemittanceRunnerNoRecordsFound;
